import { render, staticRenderFns } from "./TicketDetailsModal.vue?vue&type=template&id=2627fc7f&scoped=true"
import script from "./TicketDetailsModal.vue?vue&type=script&lang=js"
export * from "./TicketDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./TicketDetailsModal.vue?vue&type=style&index=0&id=2627fc7f&lang=css"
import style1 from "./TicketDetailsModal.vue?vue&type=style&index=1&id=2627fc7f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2627fc7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2627fc7f')) {
      api.createRecord('2627fc7f', component.options)
    } else {
      api.reload('2627fc7f', component.options)
    }
    module.hot.accept("./TicketDetailsModal.vue?vue&type=template&id=2627fc7f&scoped=true", function () {
      api.rerender('2627fc7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/customer-service/components/Modal/TicketDetailsModal.vue"
export default component.exports